import { useEffect, useState } from "react";
import { useMainContext } from "../../hooks/useMainContext";

import styles from "./nick.module.scss";

export default function Nick2(props) {
  const { name } = props;
  const [opacity, setOpacity] = useState(1);
  const { getTimeoutCounter } = useMainContext();

  useEffect(() => {
    const timeoutInterval = setInterval(
      () => setOpacity(getTimeoutCounter().timeToSignoutPerc),
      5000
    );

    return () => clearInterval(timeoutInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span style={{ opacity }} className={styles.nick}>
      {/* <Avatar src={picture} /> */}
      <span className="user-name">{name.toUpperCase()}</span>
      {/* <span
        className={`${styles.tenant} ${
          tenant.toLowerCase().includes("prod") ? styles.prod : styles.nonProd
        }`}
      >
        {tenant}
      </span> */}
    </span>
  );
}
